import {
    customReminderDatePickerAriaLabel,
    customReminderTimePickerAriaLabel,
} from './CustomReminderDatePickers.locstring.json';
import loc from 'owa-localize';
import { setSelectedDate, setSelectedTime } from '../actions/customReminderDateActions';
import getCustomReminderDate from '../selectors/getCustomReminderDate';
import { observer } from 'mobx-react-lite';
import { DropdownDatePicker } from 'owa-datepicker';
import { now } from 'owa-datetime';

import TimePicker from 'owa-timepicker/lib/components/TimePicker';
import * as React from 'react';

const styles = require('./CustomReminderDatePickers.scss');

export default observer(function CustomReminderDatePickers() {
    return (
        <>
            <DropdownDatePicker
                className={styles.datePicker}
                value={getCustomReminderDate()}
                onSelectDate={setSelectedDate}
                borderless={true}
                ariaLabel={loc(customReminderDatePickerAriaLabel)}
                minDate={now()}
            />
            <TimePicker
                className={styles.timePicker}
                selectedTime={getCustomReminderDate()}
                onChanged={setSelectedTime}
                ariaLabel={loc(customReminderTimePickerAriaLabel)}
                timePickerComboBoxRootStyle={styles.timePickerRootStyle}
            />
        </>
    );
});
